import React from 'react';

import { Box } from 'Components/Base';

import { useClearByOnDemand } from '../Contexts/ClearByOnDemandProvider/ClearByOnDemandProvider';
import ClearTicketFormView from '../Components/ClearTicketForm';

import ClearByOnDemandUploadImage from './ClearImageUpload';

const ClearTicketForm = (props) => {
  const [
    ,
    { courseName, videoTitle, videoTime, question, bookNo, pageNo, questionNo } = {},
    { goToReviewingStep },
  ] = useClearByOnDemand();

  return (
    <ClearTicketFormView
      onSubmit={goToReviewingStep}
      initialValues={{ courseName, videoTitle, videoTime, question, bookNo, pageNo, questionNo }}
      {...props}
    >
      <Box mb={7}>
        <ClearByOnDemandUploadImage />
      </Box>
    </ClearTicketFormView>
  );
};

export default ClearTicketForm;
